import { Channel } from 'generated/graphql-gateway';
import { isCateringPickup } from 'utils/service-mode';

import { ServiceMode } from '../service-mode/types';

export const getChannelByServiceMode = (serviceMode: ServiceMode | null): Channel => {
  if (isCateringPickup(serviceMode)) {
    return Channel.CATERING;
  }

  return Channel.WHITELABEL;
};
